import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_get_dock_appointment_attachmentsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { dock_appointment_id: number }): 
  Promise<{ result: { Id?: number, DockAppointmentId?: number, FileExtension?: string, FileName?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.dock_appointment_id)) {
      $missingRequiredInParams.push('\'dock_appointment_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { dock_appointment_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, DockAppointmentId?: number, FileExtension?: string, FileName?: string }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.dock_appointment_id)) {
      $missingRequiredInParams.push('\'dock_appointment_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { dock_appointment_id: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, DockAppointmentId?: number, FileExtension?: string, FileName?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.dock_appointment_id)) {
      $missingRequiredInParams.push('\'dock_appointment_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      dock_appointment_id: number    }) {
        if(isNil($inParams.dock_appointment_id)) {
          return true; 
        }
      return false;
    }
}
